export default __webpack_public_path__ + "static/illustration-content-desc.url-bcf76ee39c1e39301e187975cab36858.svg";